import { EntityState } from '@ngrx/entity';
import { IRequestLoadingIndicator } from '../IRequestLoadingIndicator.interface';

export interface RequestLoadingIndicatorState extends EntityState<IRequestLoadingIndicator> {}
